var _Path, _G, _Path2, _G2, _Path3, _G3, _Path4, _G4, _Path5, _G5, _Path6, _G6, _G7, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Mask, Path, Defs, ClipPath } from "react-native-svg";
var SvgSpinWow = function SvgSpinWow(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 188 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement(Mask, {
    id: "spin-wow_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 37,
    width: 25,
    height: 25
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M10.875 37.922h24v24h-24z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#spin-wow_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M22.875 58.672a.725.725 0 0 1-.535-.216.726.726 0 0 1-.215-.534v-7.187a7.482 7.482 0 0 1-2.883-.569 7.412 7.412 0 0 1-2.436-1.627 7.253 7.253 0 0 1-1.615-2.436 7.627 7.627 0 0 1-.556-2.883v-.615c0-.254.085-.466.257-.637a.865.865 0 0 1 .637-.258h.615c.981 0 1.93.192 2.85.575.918.382 1.73.926 2.435 1.631a7.084 7.084 0 0 1 1.287 1.753c.336.646.576 1.331.72 2.057.116-.2.244-.39.386-.569.142-.178.3-.355.474-.53a7.458 7.458 0 0 1 2.437-1.63 7.434 7.434 0 0 1 2.883-.575h.615c.253 0 .466.086.637.257a.865.865 0 0 1 .257.637v.615c0 1-.192 1.961-.575 2.883a7.456 7.456 0 0 1-1.63 2.437 7.285 7.285 0 0 1-2.425 1.614 7.533 7.533 0 0 1-2.87.557v4.5c0 .212-.072.39-.216.534a.727.727 0 0 1-.534.216Zm-.74-9.462c0-.8-.155-1.562-.463-2.287a6.087 6.087 0 0 0-1.312-1.938 6.087 6.087 0 0 0-1.938-1.312 5.786 5.786 0 0 0-2.287-.463c0 .8.15 1.567.45 2.3.3.734.733 1.384 1.3 1.95.566.567 1.216 1 1.95 1.3.733.3 1.5.45 2.3.45Zm1.49 2.712a5.924 5.924 0 0 0 4.225-1.75 6.05 6.05 0 0 0 1.313-1.95c.308-.733.462-1.5.462-2.3-.8 0-1.567.154-2.3.462a6.05 6.05 0 0 0-1.95 1.313 5.918 5.918 0 0 0-1.75 4.225Z",
    fill: "#100F0F"
  })))), /*#__PURE__*/React.createElement(G, {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement(Mask, {
    id: "spin-wow_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 37,
    width: 25,
    height: 25
  }, _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M158.875 37.922h24v24h-24z"
  }))), _G2 || (_G2 = /*#__PURE__*/React.createElement(G, {
    mask: "url(#spin-wow_svg__b)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M168.029 50.076a1 1 0 0 0-1 1v.846c0 1.061.375 1.968 1.127 2.72a3.704 3.704 0 0 0 2.719 1.126 3.704 3.704 0 0 0 2.719-1.127 3.707 3.707 0 0 0 1.127-2.72v-.941a.872.872 0 0 0-.26-.644.874.874 0 0 0-.644-.26h-5.788Zm2.846 4.5a2.562 2.562 0 0 1-1.881-.773 2.561 2.561 0 0 1-.773-1.881v-.654h5.308v.654c0 .738-.258 1.365-.773 1.88a2.562 2.562 0 0 1-1.881.774Zm-3.501-9.5c-.534 0-1.005.172-1.412.516a3.378 3.378 0 0 0-.933 1.259.417.417 0 0 0 .028.414.594.594 0 0 0 .359.263c.143.043.29.027.442-.048a.665.665 0 0 0 .323-.331c.129-.242.294-.448.495-.617.201-.17.434-.258.699-.264.265.006.498.097.699.271.201.175.366.383.495.625a.628.628 0 0 0 .32.32.602.602 0 0 0 .436.034.62.62 0 0 0 .363-.258.401.401 0 0 0 .033-.41 3.37 3.37 0 0 0-.934-1.258 2.126 2.126 0 0 0-1.413-.516Zm7 0c-.534 0-1.005.172-1.412.516a3.378 3.378 0 0 0-.933 1.259.417.417 0 0 0 .028.414.594.594 0 0 0 .359.263c.143.043.29.027.442-.048a.665.665 0 0 0 .323-.331c.123-.242.286-.45.49-.622a1.06 1.06 0 0 1 .704-.259c.265 0 .5.089.704.266.204.178.367.388.49.63a.628.628 0 0 0 .32.32.602.602 0 0 0 .436.034.62.62 0 0 0 .363-.258.401.401 0 0 0 .033-.41 3.37 3.37 0 0 0-.934-1.258 2.126 2.126 0 0 0-1.413-.516Zm-3.497 14.346a9.253 9.253 0 0 1-3.705-.748 9.583 9.583 0 0 1-3.017-2.03 9.584 9.584 0 0 1-2.032-3.016 9.244 9.244 0 0 1-.748-3.705c0-1.313.249-2.548.748-3.705a9.599 9.599 0 0 1 2.03-3.017 9.59 9.59 0 0 1 3.016-2.03 9.245 9.245 0 0 1 3.704-.75c1.314 0 2.549.25 3.705.749a9.583 9.583 0 0 1 3.017 2.03 9.583 9.583 0 0 1 2.032 3.016 9.243 9.243 0 0 1 .748 3.704 9.249 9.249 0 0 1-.748 3.705 9.599 9.599 0 0 1-2.03 3.017 9.59 9.59 0 0 1-3.016 2.031 9.245 9.245 0 0 1-3.704.749Zm-.002-1.5c2.233 0 4.125-.775 5.675-2.325 1.55-1.55 2.325-3.442 2.325-5.675 0-2.233-.775-4.125-2.325-5.675-1.55-1.55-3.442-2.325-5.675-2.325-2.233 0-4.125.775-5.675 2.325-1.55 1.55-2.325 3.441-2.325 5.675 0 2.233.775 4.125 2.325 5.675 1.55 1.55 3.442 2.325 5.675 2.325Z",
    fill: "#100F0F"
  })))), /*#__PURE__*/React.createElement(G, {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement(Mask, {
    id: "spin-wow_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 0,
    width: 25,
    height: 24
  }, _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M54.875 0h24v24h-24z"
  }))), _G3 || (_G3 = /*#__PURE__*/React.createElement(G, {
    mask: "url(#spin-wow_svg__c)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "m76.12 8.674-2.312-3.829A1.767 1.767 0 0 0 72.307 4H61.436c-.61 0-1.191.328-1.502.845l-2.312 3.829a1.75 1.75 0 0 0 .26 2.128l7.748 8.69c.34.339.79.508 1.241.508.45 0 .901-.169 1.242-.507l7.747-8.691c.57-.567.681-1.442.26-2.128Zm-13.743 1.8 2.162 5.827-4.865-5.827h2.703Zm5.986-4.972 1.401 3.48H63.97l1.4-3.48H68.364Zm1.351 4.972-2.853 7.358-2.853-7.358H69.715Zm1.642 0h2.703L69.194 16.3l2.162-5.827Zm1.161-4.853 2.032 3.361h-3.173l-1.401-3.48h2.332c.09 0 .17.05.21.119Zm-11.301 0c.04-.08.13-.12.21-.12h2.332l-1.401 3.481h-3.173l2.032-3.361Z",
    fill: "#100F0F"
  })))), /*#__PURE__*/React.createElement(G, {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement(Mask, {
    id: "spin-wow_svg__d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 0,
    width: 25,
    height: 24
  }, _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M115.875 0h24v24h-24z"
  }))), _G4 || (_G4 = /*#__PURE__*/React.createElement(G, {
    mask: "url(#spin-wow_svg__d)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.877 21.5a9.254 9.254 0 0 1-3.705-.748 9.585 9.585 0 0 1-3.017-2.03 9.583 9.583 0 0 1-2.032-3.016 9.243 9.243 0 0 1-.748-3.704c0-1.314.249-2.55.748-3.705a9.599 9.599 0 0 1 2.03-3.018 9.59 9.59 0 0 1 3.016-2.03 9.245 9.245 0 0 1 3.704-.749c1.314 0 2.549.25 3.705.748a9.584 9.584 0 0 1 3.017 2.03 9.583 9.583 0 0 1 2.032 3.016 9.243 9.243 0 0 1 .748 3.704 9.249 9.249 0 0 1-.748 3.705 9.6 9.6 0 0 1-2.03 3.018 9.591 9.591 0 0 1-3.016 2.03 9.245 9.245 0 0 1-3.704.749Zm-.002-1.5c2.217 0 4.104-.78 5.662-2.337 1.559-1.559 2.338-3.446 2.338-5.663s-.779-4.104-2.338-5.663C131.979 4.78 130.092 4 127.875 4s-4.104.78-5.663 2.337c-1.558 1.559-2.337 3.446-2.337 5.663s.779 4.104 2.337 5.663c1.559 1.558 3.446 2.337 5.663 2.337Zm-4.438-8.747a4.503 4.503 0 0 1 3.691-3.691c.409-.069.747-.398.747-.812 0-.414-.337-.755-.749-.704a6.003 6.003 0 0 0-5.205 5.205c-.051.412.29.749.704.749s.743-.338.812-.747ZM127.875 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm4.438-1.253a4.503 4.503 0 0 1-3.691 3.691c-.409.069-.747.398-.747.812 0 .414.337.755.749.704a6.003 6.003 0 0 0 5.205-5.206c.051-.41-.29-.748-.704-.748s-.743.338-.812.747Z",
    fill: "#100F0F"
  })))), /*#__PURE__*/React.createElement(G, {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement(Mask, {
    id: "spin-wow_svg__e",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 87,
    width: 24,
    height: 25
  }, _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 87.922h24v24H0z"
  }))), _G5 || (_G5 = /*#__PURE__*/React.createElement(G, {
    mask: "url(#spin-wow_svg__e)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "m5.002 99.478-2.154-2.154a.85.85 0 0 1-.266-.633.885.885 0 0 1 .276-.633l2.144-2.144a.867.867 0 0 1 .633-.271c.24 0 .452.09.632.271l2.145 2.144c.18.181.27.392.27.633s-.09.452-.27.633l-2.145 2.144a.885.885 0 0 1-.632.276.85.85 0 0 1-.633-.266Zm5.306 9.944a.876.876 0 0 1-.644-.26.874.874 0 0 1-.26-.644v-3.894a42.46 42.46 0 0 1-2.548-.279c-.84-.118-1.68-.27-2.521-.456a.944.944 0 0 1-.539-.355.636.636 0 0 1-.113-.598.756.756 0 0 1 .392-.476.872.872 0 0 1 .625-.071 26.09 26.09 0 0 0 3.627.575 42.036 42.036 0 0 0 7.346 0c1.22-.106 2.43-.298 3.627-.575a.878.878 0 0 1 .625.07.75.75 0 0 1 .392.472.644.644 0 0 1-.113.603.944.944 0 0 1-.538.355c-.841.186-1.682.338-2.522.456-.84.118-1.69.211-2.548.279v3.894a.874.874 0 0 1-.26.644.876.876 0 0 1-.644.26h-3.384Zm-4.673-11.41 1.311-1.32-1.311-1.313-1.321 1.312 1.32 1.321ZM12 95.114a2.559 2.559 0 0 1-1.88-.774 2.56 2.56 0 0 1-.774-1.88c0-.737.258-1.363.774-1.88a2.56 2.56 0 0 1 1.88-.773 2.56 2.56 0 0 1 1.88.773 2.56 2.56 0 0 1 .774 1.88 2.56 2.56 0 0 1-.774 1.88 2.559 2.559 0 0 1-1.88.774Zm0 6.702a1.78 1.78 0 0 1-1.304-.542 1.779 1.779 0 0 1-.542-1.304c0-.508.18-.942.542-1.304A1.778 1.778 0 0 1 12 98.124c.508 0 .942.18 1.304.542.361.362.542.796.542 1.304s-.18.942-.542 1.304a1.78 1.78 0 0 1-1.304.542Zm0-8.202c.322 0 .595-.112.818-.335.224-.224.336-.497.336-.819 0-.322-.112-.594-.336-.818a1.114 1.114 0 0 0-.818-.335c-.322 0-.595.111-.818.335a1.113 1.113 0 0 0-.336.818c0 .322.112.595.336.819.223.223.496.335.818.335Zm4.765 5.779-1.005-1.75a.894.894 0 0 1-.116-.45c0-.165.039-.317.116-.454l1.005-1.75a.802.802 0 0 1 .32-.336.905.905 0 0 1 .453-.116h1.952c.167 0 .318.039.454.116.136.077.243.189.32.336l1.005 1.75a.894.894 0 0 1 .116.45.912.912 0 0 1-.116.454l-1.005 1.75a.802.802 0 0 1-.32.337.904.904 0 0 1-.454.115H17.54a.905.905 0 0 1-.454-.115.802.802 0 0 1-.32-.337Zm1.111-1.048h1.28l.636-1.154-.64-1.154h-1.279l-.636 1.154.64 1.154Z",
    fill: "#100F0F"
  })))), /*#__PURE__*/React.createElement(G, {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement(Mask, {
    id: "spin-wow_svg__f",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 87,
    width: 24,
    height: 25
  }, _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M164 87.922h24v24h-24z"
  }))), _G6 || (_G6 = /*#__PURE__*/React.createElement(G, {
    mask: "url(#spin-wow_svg__f)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M182.819 96.193a.5.5 0 0 1-.911 0l-.603-1.328a.5.5 0 0 0-.248-.248l-1.328-.604a.5.5 0 0 1 0-.91l1.328-.603a.5.5 0 0 0 .248-.249l.603-1.328a.5.5 0 0 1 .911 0l.603 1.328c.05.11.139.198.249.248l1.328.604a.5.5 0 0 1 0 .91l-1.328.604a.501.501 0 0 0-.249.248l-.603 1.328Zm0 12.727a.5.5 0 0 1-.911 0l-.603-1.327a.501.501 0 0 0-.248-.249l-1.328-.603a.5.5 0 0 1 0-.911l1.328-.603a.497.497 0 0 0 .248-.249l.603-1.327a.5.5 0 0 1 .911 0l.603 1.327a.5.5 0 0 0 .249.249l1.328.603a.5.5 0 0 1 0 .911l-1.328.603a.503.503 0 0 0-.249.249l-.603 1.327Zm-9.091-2.727a.5.5 0 0 1-.91 0l-1.74-3.828a.501.501 0 0 0-.249-.248l-3.828-1.74a.5.5 0 0 1 0-.91l3.828-1.74a.501.501 0 0 0 .249-.249l1.74-3.827a.5.5 0 0 1 .91 0l1.74 3.828a.5.5 0 0 0 .248.248l3.828 1.74a.5.5 0 0 1 0 .91l-3.828 1.74a.5.5 0 0 0-.248.248l-1.74 3.828Z",
    fill: "#100F0F"
  })))), _G7 || (_G7 = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#spin-wow_svg__g)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M95.5 77.46H61c0-9.527 3.369-17.658 10.105-24.395L95.5 77.46Z",
    fill: "#F9F39E"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "m95.5 77.46-24.396 24.396C64.369 95.12 61 86.988 61 77.46h34.5Z",
    fill: "#9EF9A7"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M95.5 77.46v34.5c-9.528 0-17.659-3.369-24.396-10.105l24.395-24.396v.001Z",
    fill: "#4BDBB3"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "m95.5 77.46 24.395 24.396c-6.736 6.736-14.868 10.105-24.395 10.105v-34.5Z",
    fill: "#00D2DA"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M95.5 77.46h34.499c0 9.528-3.369 17.659-10.105 24.396L95.498 77.46h.001Z",
    fill: "#69BCF8"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "m95.5 77.46 24.395-24.395C126.631 59.8 130 67.933 130 77.46H95.5Z",
    fill: "#ADA9FF"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M95.5 77.46v-34.5c9.527 0 17.658 3.37 24.395 10.106L95.5 77.461Z",
    fill: "#DB94D7"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "spin-wow_svg__g"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(61 42.96)",
    d: "M0 0h69v69H0z"
  })))));
};
export default SvgSpinWow;